<template>
    <div> 
        <h3 class="text-center">AUTORISATION PARENTALE</h3>
        <div class="bg-red-100 p-6">
            <div class="inline-block mt-4 w-full md:pr-2">
                <label class="text-sm block text-red-900 font-bold" for="soussignes_parents">
                    <span v-html="__('soussignes_parents')"></span>
                    <sup class="text-red-500">*</sup>
                </label>
                <input v-model="$parent.form.autorisation_parentale.soussignes_parents"
                :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                id="soussignes_parents"
                name="soussignes_parents"
                type="text"
                required>
                <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_parentale}">
                    {{ __($parent.form.errors.autorisation_parentale) }}
                </p>
            </div>
            <ol class="list-decimal list-inside text-red-900">
                <li>
                    <span v-html="__('consentement_responsabilite_enfant')"></span>
                    <ul class="pl-8">
                        <li v-html="__('consentement_pension_famille')"></li>
                        <li v-html="__('consentement_demi_pension')"></li>
                    </ul>
                </li>
                <li>
                    <span v-html="__('autorisons_responsables')"></span>
                    <ul class="list-disc list-inside pl-8">
                        <li v-html="__('autorisons_responsables_1')"></li>
                        <li v-html="__('autorisons_responsables_2')"></li>
                        <li v-html="__('autorisons_responsables_3')"></li>
                    </ul>
                </li>
                <li>
                    <span v-html="__('info_sante_enfant')"></span>
                    <textarea v-model="$parent.form.autorisation_parentale.info_sante_enfant" name="info_sante_enfant" id="info_sante_enfant" class="w-full" rows="3"></textarea>
                </li>
                <li>
                    <span v-html="__('prenons_bien_compte')"></span>
                </li>
                <li>
                    <span v-html="__('avis_cas_urgence')"></span>
                </li>
            </ol>
            <div>
                <div class="flex gap-4 flex-col md:flex-row">
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="text-sm block text-red-900 font-bold" for="nom_enfant">
                            <span v-html="__('nom_enfant')"></span>
                            <sup class="text-red-500">*</sup>
                        </label>
                        <input v-model="$parent.form.autorisation_parentale.nom_enfant"
                        :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                        class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                        id="nom_enfant"
                        name="nom_enfant"
                        type="text"
                        required>
                        <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_parentale}">
                            {{ __($parent.form.errors.autorisation_parentale) }}
                        </p>
                    </div>
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="text-sm block text-red-900 font-bold" for="nationalite">
                            <span v-html="__('nationalite')"></span>
                            <sup class="text-red-500">*</sup>
                        </label>
                        <input v-model="$parent.form.autorisation_parentale.nationalite"
                        :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                        class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                        id="nationalite"
                        name="nationalite"
                        type="text"
                        required>
                        <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_parentale}">
                            {{ __($parent.form.errors.autorisation_parentale) }}
                        </p>
                    </div>
                </div>
                <div class="flex gap-4 flex-col md:flex-row">
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="block text-red-900 font-bold text-base" for="date_naissance">{{ __('date_naissance') }} <sup class="text-red-500">*</sup></label>
                        <input v-model="$parent.form.autorisation_parentale.date_naissance"
                            placeholder="YYYY-MM-DD"
                            min="1900-01-01"
                            :max="new Date().toISOString().split('T')[0]"
                            :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                            class="cursor-pointer w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                            id="date_naissance" name="date_naissance" type="date" required
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                    </div>
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="text-sm block text-red-900 font-bold" for="lieu_naissance">
                            <span v-html="__('lieu_naissance')"></span>
                            <sup class="text-red-500">*</sup>
                        </label>
                        <input v-model="$parent.form.autorisation_parentale.lieu_naissance"
                        :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                        class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                        id="lieu_naissance"
                        name="lieu_naissance"
                        type="text"
                        required>
                        <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_parentale}">
                            {{ __($parent.form.errors.autorisation_parentale) }}
                        </p>
                    </div>
                </div>
                <div class="flex gap-4">
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <div>
                            <label class="text-sm block text-red-900 font-bold" for="fait_a">
                                <span v-html="__('fait_a')"></span>
                                <sup class="text-red-500">*</sup>
                            </label>
                            <input v-model="$parent.form.autorisation_parentale.fait_a"
                            :class="{'border-red-500':$parent.form.errors.autorisation_parentale}"
                            class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                            id="fait_a"
                            name="fait_a"
                            type="text"
                            required>
                            <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_parentale}">
                                {{ __($parent.form.errors.autorisation_parentale) }}
                            </p>
                        </div>
                        <label class="block text-red-900 font-bold text-base" for="fait_le">{{ __('fait_le') }} <sup class="text-red-500">*</sup></label>
                        <input v-model="$parent.form.autorisation_parentale.fait_le"
                            placeholder="YYYY-MM-DD"
                            min="1900-01-01"
                            :max="new Date().toISOString().split('T')[0]"
                            :class="{'border-red-500':$parent.form.errors.fait_le}"
                            class="cursor-pointer w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                            id="fait_le" name="fait_le" type="date" required
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                        <span class="text-gray-500 italic ">{{ __('format_date_jma') }}</span>
                    </div>
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <div class="flex flex-col">
                            <label class="inline-flex items-start mx-2 cursor-pointer">
                                <input v-model="$parent.form.autorisation_parentale.autorisation" type="radio" name="autorisation" :value="true" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                                <span for="oui" class="ml-2 text-red-900" v-html="__('autorise_parent')"></span>
                            </label>
                            <label class="inline-flex items-center mx-2 cursor-pointer">
                                <input v-model="$parent.form.autorisation_parentale.autorisation" type="radio" name="autorisation" :value="false" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                                <span for="non" class="ml-2 text-red-900" v-html="__('autorise_parent_non')"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <h3 class="text-center">AUTORISATION DE DROIT À L'IMAGE</h3>
        <div class="bg-red-100 p-6">
            <p class="text-red-900" v-html="__('autorisation_droit_image')"></p>
            <div>
                <div class="my-2">
                    <label class="text-red-900 font-bold">{{ __('je_soussigne') }}</label>
                    <div class="grid grid-cols-2 items-center">
                        <div>
                            <label class="inline-flex items-center mx-2 cursor-pointer">
                                <input v-model="$parent.form.autorisation_image.soussignes_civilite" type="radio" name="je_soussigne" :value="'monsieur'" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                                <span for="oui" class="ml-2 text-red-900 font-bold">{{ __('monsieur') }}</span>
                            </label>
                            <label class="inline-flex items-center mx-2 cursor-pointer">
                                <input v-model="$parent.form.autorisation_image.soussignes_civilite" type="radio" name="je_soussigne" :value="'madame'" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                                <span for="non" class="ml-2 text-red-900 font-bold">{{ __('madame') }}</span>
                            </label>
                        </div>
                        <input v-model="$parent.form.autorisation_image.soussignes_nom" type="text" name="parent_nom" id="parent_nom" class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary" required>
                    </div>
                </div>
                <div class="grid grid-cols-2 items-center">
                    <label class="text-sm block text-red-900 font-bold" for="pere_mere_tuteur">
                        <span v-html="__('pere_mere_tuteur')"></span>
                        <sup class="text-red-500">*</sup>
                    </label>
                    <input v-model="$parent.form.autorisation_image.enfant"
                    :class="{'border-red-500':$parent.form.errors.autorisation_image}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="pere_mere_tuteur"
                    name="pere_mere_tuteur"
                    type="text"
                    required>
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.autorisation_image}">
                        {{ __($parent.form.errors.autorisation_image) }}
                    </p>
                </div>
                <div>
                    <div class="flex flex-col gap-4">
                        <label class="inline-flex items-start mx-2 cursor-pointer">
                            <input v-model="$parent.form.autorisation_image.autorise" type="radio" name="autorise_photo" :value="true" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                            <span for="oui" class="ml-2 text-red-900" v-html="__('autorise_photo')"></span>
                        </label>
                        <label class="inline-flex items-center mx-2 cursor-pointer">
                            <input v-model="$parent.form.autorisation_image.autorise" type="radio" name="autorise_photo" :value="false" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                            <span for="non" class="ml-2 text-red-900" v-html="__('autorise_photo_non')"></span>
                        </label>
                    </div>
                </div>
                <div class="flex justify-end">
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="block text-red-900 font-bold text-base" for="date">{{ __('date') }} <sup class="text-red-500">*</sup></label>
                        <input v-model="$parent.form.autorisation_image.date"
                            placeholder="YYYY-MM-DD"
                            min="1900-01-01"
                            :max="new Date().toISOString().split('T')[0]"
                            :class="{'border-red-500':$parent.form.errors.autorisation_image}"
                            class="cursor-pointer w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                            id="date" name="date" type="date" required
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                        <span class="text-gray-500 italic ">{{ __('format_date_jma') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <h3 class="text-center">RENSEIGNEMENTS SUR L'ENFANT ET SES PARENTS (ou responsables légaux)</h3>
        <div class="bg-red-100 p-6">
            <div>
                <p class="text-red-900 font-bold">{{ __('recommandation_parents') }}</p>
                <textarea v-model="$parent.form.renseignements_enfant_parent.recommandation_parents" name="recommandation_parents" id="recommandation_parents" class="w-full" rows="2"></textarea>
            </div>
            <div>
                <p class="text-red-900 font-bold">{{ __('regime_alimentaire_allergies') }}</p>
                <textarea v-model="$parent.form.renseignements_enfant_parent.regime_alimentaire" name="regime_alimentaire_allergies" id="regime_alimentaire_allergies" class="w-full" rows="2"></textarea>
            </div>
            <div>
                <div>
                    <p class="text-red-900 font-bold">{{ __('renseignements_medicaux') }} <span class="text-gray-500 italic font-normal">{{ __('renseignements_medicaux_info') }}</span></p>
                </div>
                <textarea v-model="$parent.form.renseignements_enfant_parent.renseignements_medicaux" name="renseignements_medicaux" id="renseignements_medicaux" class="w-full" rows="2"></textarea>
            </div>
            <p class="text-center text-red-900 font-bold">{{ __('verifier_vaccins_a_jour') }}</p>
            <div class="flex justify-center">
                <p class="text-red-900">{{ __('autorisation_baignade') }}</p>
                <div>
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="$parent.form.renseignements_enfant_parent.baignade" type="radio" name="autorisation_baignade" :value="true" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                        <span for="oui" class="ml-2 text-red-900 font-bold">{{ __('oui') }}</span>
                    </label>
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="$parent.form.renseignements_enfant_parent.baignade" type="radio" name="autorisation_baignade" :value="false" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required>
                        <span for="non" class="ml-2 text-red-900 font-bold">{{ __('non') }}</span>
                    </label>
                </div>
            </div>
            <div class="w-full h-0.5 bg-white mx-auto"></div>
            <div class="inline-block mt-4 w-full">
                <label class="text-sm block text-red-900 font-bold" for="nom_responsable_enfant">
                    <span v-html="__('nom_responsable_enfant')"></span>
                    <sup class="text-red-500">*</sup>
                </label>
                <input v-model="$parent.form.renseignements_enfant_parent.responsable_nom"
                :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                id="nom_responsable_enfant"
                name="nom_responsable_enfant"
                type="text"
                required>
                <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                    {{ __($parent.form.errors.renseignements_enfant_parent) }}
                </p>
            </div>
            <div class="flex gap-4">
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-red-900 font-bold" for="telephone">
                        <span v-html="__('telephone')"></span>
                        <sup class="text-red-500">*</sup>
                    </label>
                    <input v-model="$parent.form.renseignements_enfant_parent.responsable_tel"
                    :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="telephone"
                    name="telephone"
                    type="text"
                    required>
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                        {{ __($parent.form.errors.renseignements_enfant_parent) }}
                    </p>
                </div>
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-red-900 font-bold" for="adresse">
                        <span v-html="__('adresse')"></span>
                        <sup class="text-red-500">*</sup>
                    </label>
                    <input v-model="$parent.form.renseignements_enfant_parent.responsable_adresse"
                    :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="adresse"
                    name="adresse"
                    type="text"
                    required>
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                        {{ __($parent.form.errors.renseignements_enfant_parent) }}
                    </p>
                </div>
            </div>
            <div class="flex gap-4">
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-red-900 font-bold" for="telephone">
                        <span v-html="__('telephone2')"></span>
                    </label>
                    <input v-model="$parent.form.renseignements_enfant_parent.responsable_tel2"
                    :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="telephone"
                    name="telephone"
                    type="text">
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                        {{ __($parent.form.errors.renseignements_enfant_parent) }}
                    </p>
                </div>
                <div class="flex gap-4">
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="text-sm block text-red-900 font-bold" for="code_postal">
                            <span v-html="__('code_postal')"></span>
                            <sup class="text-red-500">*</sup>
                        </label>
                        <input v-model="$parent.form.renseignements_enfant_parent.responsable_code_postal"
                        :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                        class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                        id="code_postal"
                        name="code_postal"
                        type="text"
                        required>
                        <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                            {{ __($parent.form.errors.renseignements_enfant_parent) }}
                        </p>
                    </div>
                    <div class="inline-block mt-4 w-full md:w-1/2">
                        <label class="text-sm block text-red-900 font-bold" for="ville">
                            <span v-html="__('ville')"></span>
                            <sup class="text-red-500">*</sup>
                        </label>
                        <input v-model="$parent.form.renseignements_enfant_parent.responsable_ville"
                        :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                        class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                        id="ville"
                        name="ville"
                        type="text"
                        required>
                        <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                            {{ __($parent.form.errors.renseignements_enfant_parent) }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex gap-4">
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-red-900 font-bold" for="adresse_email">
                        <span v-html="__('adresse_email')"></span>
                        <sup class="text-red-500">*</sup>
                    </label>
                    <input v-model="$parent.form.renseignements_enfant_parent.responsable_mail"
                    :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="adresse_email"
                    name="adresse_email"
                    type="text"
                    required>
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                        {{ __($parent.form.errors.renseignements_enfant_parent) }}
                    </p>
                </div>
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-red-900 font-bold" for="pays">
                        <span v-html="__('pays')"></span>
                        <sup class="text-red-500">*</sup>
                    </label>
                    <input v-model="$parent.form.renseignements_enfant_parent.responsable_pays"
                    :class="{'border-red-500':$parent.form.errors.renseignements_enfant_parent}"
                    class="w-full px-2 py-2 text-gray-700 rounded-sm border-cavilam-primary"
                    id="pays"
                    name="pays"
                    type="text"
                    required>
                    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.renseignements_enfant_parent}">
                        {{ __($parent.form.errors.renseignements_enfant_parent) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputForm from "@/Components/InputForm";
export default {
    name: "AutorisationParentale",
    components: {
        InputForm,
    },
    props: {
        
    },
    data() {
        return {
            form: this.$parent.form, // InputForm a besoin que le parent ait un form
        }
    },
    // mounted() {
    //     console.log(this.$parent.form);
    // },
}
</script>